export default __webpack_public_path__ + "static/media/hayk.7312236b.jpg";